import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { "uk-icon": "icon: file-edit" }, null, -1)
const _hoisted_3 = ["uk-tooltip"]
const _hoisted_4 = ["uk-tooltip"]
const _hoisted_5 = ["uk-tooltip"]
const _hoisted_6 = ["uk-tooltip"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: `action-icons-${_ctx.externalIndex}`,
    class: "templates-action-icons"
  }, [
    (_ctx.canEdit)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: `/templates/${_ctx.slug}/edit?kind=${_ctx.kind}`,
          title: _ctx.$t('index_templates.templates_table.action_names.edit'),
          class: "uk-margin-small-right"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to", "title"]))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          "uk-icon": "icon: file-edit",
          class: "action-icon disabled-icon uk-margin-small-right",
          "uk-tooltip": _ctx.$t('permissions.action_not_allowed')
        }, null, 8, _hoisted_3)),
    _createElementVNode("span", {
      "uk-icon": "icon: export-notes",
      class: _normalizeClass(["action-icon uk-margin-small-right", { 'disabled-icon': !_ctx.canExport }]),
      "uk-tooltip": 
        _ctx.canExport
          ? _ctx.$t('index_templates.templates_table.action_names.export')
          : _ctx.$t('permissions.action_not_allowed')
      ,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.canExport && _ctx.$emit('export')))
    }, null, 10, _hoisted_4),
    _createElementVNode("span", {
      "uk-icon": "icon: copy",
      class: _normalizeClass(["action-icon uk-margin-right", { 'disabled-icon': !_ctx.canCopy }]),
      "uk-tooltip": _ctx.canCopy ? undefined : _ctx.$t('permissions.action_not_allowed'),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.canCopy && _ctx.$emit('copy')))
    }, null, 10, _hoisted_5),
    _createElementVNode("span", {
      "uk-icon": "icon: trash",
      class: _normalizeClass(["action-icon", { 'disabled-icon': !_ctx.canDelete }]),
      "uk-tooltip": _ctx.canDelete ? undefined : _ctx.$t('permissions.action_not_allowed'),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.canDelete && _ctx.$emit('delete')))
    }, null, 10, _hoisted_6)
  ], 8, _hoisted_1))
}